import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-22/task-01";

const task: Slide = {
  titleHtml: "Convert values from Pascal to dB SPL and</br>vice versa without a calculator (we trust you here!).",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 1,
      components: [
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
